import { theme } from '@theme'

export const config = {
  titleSection: {
    title: 'Hi! Just a few seconds, well get you on the right way.',
  },
  imageSection: {
    src: '/images/redirect.webp',
    alt: 'redirect',
    imageBottom: '-110',
    imageRight: '-200',
    width: '645',
    height: '555',
  },
  imageHexagon: {
    src: '/images/hexagon_redirect.webp',
    alt: 'hexagon',
    width: '136',
    height: '16',
  },
  wrapperSection: {
    repeatImageRight: '0',
    textColor: theme.colors.milkyWhite,
    background: theme.colors.gradientGray,
  },
}
